module.exports = __webpack_public_path__ + "img/security-1.ca17b28f.webp";